import { HTTPClient } from '../utils/request'

export default {
  get: ({ query }) => HTTPClient.get(`/providers${query}`),
  update: ({ params, payload }) =>
    HTTPClient.put(`/providers/${params._id}`, payload),
  store: ({ payload }) =>
    HTTPClient.post(`/providers`, payload),
  favor: ({ params }) => HTTPClient.post(`/providers/${params._id}/favorite`),
  exists: ({ query = `` }) => HTTPClient.get(`/is_exist/provider${query}`),
  status: ({ params, payload }) =>
    HTTPClient.patch(`/providers/${params._id}`, payload),
  blockProtheus: ({ params }) => HTTPClient.post(`/providers/${params._id}/sync-in-provider-protheus-block`),
}
